import '../../../design/landing/membership/index.scss';
import * as tts from "../../common/tts";
import * as React from "react";
import { render } from 'react-dom';
import { PricingTable } from './components/PricingTable';
document.addEventListener('DOMContentLoaded', function () {
    initPricingTable();
    handleWelcomeAnalytics();
});
var initPricingTable = function () {
    var _a, _b;
    var container = document.querySelector('#pricingTable');
    if (!container) {
        return;
    }
    var id = (_a = container.getAttribute('data-id')) !== null && _a !== void 0 ? _a : '';
    var key = (_b = container.getAttribute('data-publishable-key')) !== null && _b !== void 0 ? _b : '';
    render(React.createElement(PricingTable, { id: id, publishableKey: key }), container);
};
var handleWelcomeAnalytics = function () {
    if (window.location.href.includes('/welcome') === false) {
        return;
    }
    var data = {
        uri: window.location.href,
        event: 'subscribed',
        utm_source: localStorage.getItem('pw_context'),
        utm_content: localStorage.getItem('pw_segment')
    };
    if (!data['utm_source'] && !data['utm_content']) {
        return;
    }
    tts.custom(data, 'membership_welcome');
    localStorage.removeItem('pw_context');
    localStorage.removeItem('pw_segment');
};
